import React from "react"
import PropTypes from "prop-types"
import { Grid, CmsImage } from "@bw/bits"
import { TeaserHorizontal } from "@bw/partials"
import Event from "../../../models/event"
import dateFormat from "../../../utils/dateFormat"

const ListOfEvents = ({ groupByDate, events, numberOfColumns }) => {
  const allEvents = React.useMemo(() => {
    return events.reduce((acc, item) => {
      const group = !groupByDate ? "all" : dateFormat(item.startDate)

      if (!acc.hasOwnProperty(group)) {
        acc[group] = { title: group, events: [] }
      }

      acc[group].events.push(
        <TeaserHorizontal
          key={item.id}
          suptitle={groupByDate ? item.startTime : item.getStartDate()}
          title={item.title}
          excerpt={item.teaserExcerpt}
          image={
            item.teaserImage ? (
              <CmsImage
                src={item.teaserImage}
                alt={item.teaserImage?.alt || item.title}
              />
            ) : null
          }
          to={item.url}
        />
      )
      return acc
    }, {})
  }, [events, groupByDate])

  if (events.length === 0) {
    return null
  }

  return Object.values(allEvents).map((group, i) => (
    <React.Fragment key={i}>
      {groupByDate && (
        <h3 style={{ margin: i === 0 ? "0 0 1.5em" : "3em 0 1.5em" }}>
          {group.title}
        </h3>
      )}
      <Grid columns={numberOfColumns} gap="large">
        {group.events}
      </Grid>
    </React.Fragment>
  ))
}

ListOfEvents.propTypes = {
  numberOfColumns: PropTypes.number,
  groupByDate: PropTypes.bool,
  events: PropTypes.arrayOf(PropTypes.instanceOf(Event)),
}

ListOfEvents.defaultProps = {
  numberOfColumns: 3,
  groupByDate: false,
  events: [],
}

export { ListOfEvents }
